export default __webpack_public_path__ + "img/jnpa-logo.001ec1e0.png";